import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import modelClassRequire from "@kaspernj/api-maker/build/model-class-require.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "resource": {
      "column": null,
      "name": "resource",
      "selected_by_default": null,
      "translated": null
    },
    "resource_id": {
      "column": {
        "default": null,
        "name": "resource_id",
        "null": false,
        "type": null
      },
      "name": "resource_id",
      "selected_by_default": null,
      "translated": null
    },
    "resource_type": {
      "column": {
        "default": null,
        "name": "resource_type",
        "null": false,
        "type": "string"
      },
      "name": "resource_type",
      "selected_by_default": null,
      "translated": null
    },
    "state": {
      "column": {
        "default": "new",
        "name": "state",
        "null": false,
        "type": "string"
      },
      "name": "state",
      "selected_by_default": null,
      "translated": null
    },
    "total_price": {
      "column": null,
      "name": "total_price",
      "selected_by_default": null,
      "translated": null
    },
    "translated_state": {
      "column": null,
      "name": "translated_state",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "Invoice",
  "collectionKey": "invoices",
  "collectionName": "invoices",
  "i18nKey": "invoice",
  "camelizedLower": "invoice",
  "name": "Invoice",
  "nameDasherized": "invoice",
  "pluralName": "invoices",
  "ransackable_associations": [
    {
      "className": "Invoice::Audit",
      "collectionName": "invoice_audits",
      "foreignKey": "invoice_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "InvoiceAudit",
      "through": null
    },
    {
      "className": "Invoice::Audit",
      "collectionName": "invoice_audits",
      "foreignKey": "invoice_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "InvoiceAudit",
      "through": null
    },
    {
      "className": "InvoiceLine",
      "collectionName": "invoice_lines",
      "foreignKey": "invoice_id",
      "name": "invoice_lines",
      "macro": "has_many",
      "resource_name": "InvoiceLine",
      "through": null
    },
    {
      "className": "Resource",
      "collectionName": null,
      "foreignKey": "resource_id",
      "name": "resource",
      "macro": "belongs_to",
      "resource_name": null,
      "through": null
    },
    {
      "className": "SubscriptionPeriod",
      "collectionName": "subscription_periods",
      "foreignKey": "resource_id",
      "name": "subscription_period",
      "macro": "belongs_to",
      "resource_name": "SubscriptionPeriod",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "resource_id",
      "column": {
        "default": null,
        "name": "resource_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "resource_type",
      "column": {
        "default": null,
        "name": "resource_type",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "state",
      "column": {
        "default": "new",
        "name": "state",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "where_cents_summed_gteq"
    },
    {
      "name": "where_cents_summed_lteq"
    }
  ],
  "relationships": [
    {
      "className": "InvoiceLine",
      "collectionName": "invoice_lines",
      "foreignKey": "invoice_id",
      "name": "invoice_lines",
      "macro": "has_many",
      "resource_name": "InvoiceLine",
      "through": null
    },
    {
      "className": "SubscriptionPeriod",
      "collectionName": "subscription_periods",
      "foreignKey": "resource_id",
      "name": "subscription_period",
      "macro": "belongs_to",
      "resource_name": "SubscriptionPeriod",
      "through": null
    }
  ],
  "paramKey": "invoice",
  "primaryKey": "id"
}

/** Frontend model for Invoice. */
class Invoice extends BaseModel {
  /** @returns {Record<string, any>} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {any} */
  resource() {
    return this.readAttributeUnderscore("resource")
  }

  /** @returns {boolean} */
  hasResource() {
    const value = this.resource()

    return this._isPresent(value)
  }

  /** @returns {any} */
  resourceId() {
    return this.readAttributeUnderscore("resource_id")
  }

  /** @returns {boolean} */
  hasResourceId() {
    const value = this.resourceId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  resourceType() {
    return this.readAttributeUnderscore("resource_type")
  }

  /** @returns {boolean} */
  hasResourceType() {
    const value = this.resourceType()

    return this._isPresent(value)
  }

  /** @returns {string} */
  state() {
    return this.readAttributeUnderscore("state")
  }

  /** @returns {boolean} */
  hasState() {
    const value = this.state()

    return this._isPresent(value)
  }

  /** @returns {any} */
  totalPrice() {
    return this.readAttributeUnderscore("total_price")
  }

  /** @returns {boolean} */
  hasTotalPrice() {
    const value = this.totalPrice()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedState() {
    return this.readAttributeUnderscore("translated_state")
  }

  /** @returns {boolean} */
  hasTranslatedState() {
    const value = this.translatedState()

    return this._isPresent(value)
  }

  /** @returns {string} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./invoice-line.js").default>} */
  invoiceLines() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("InvoiceLine")

    const ransack = {}

    ransack["invoice_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "invoice_lines",
        model: this,
        modelName: "InvoiceLine",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./invoice-line.js").default>>} */
  loadInvoiceLines() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("InvoiceLine")

    const ransack = {}

    ransack["invoice_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "invoice_lines",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("./subscription-period.js").default | null} */
  subscriptionPeriod() {
    return this._readBelongsToReflection({reflectionName: "subscription_period"})
  }

  /** @returns {Promise<import("./subscription-period.js").default | null>} */
  loadSubscriptionPeriod() {
    if (!("resourceId" in this)) throw new Error("Foreign key method wasn't defined: resourceId")

    const id = this.resourceId()
    const modelClass = modelClassRequire("SubscriptionPeriod")
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {reflectionName: "subscription_period", model: this, modelClass},
      {ransack}
    )
  }
}

export default Invoice
